(function ($) {
	$.fn.lockedResourceModal = function () {
		const styleBackdrop = ($self) => {
			const $backdrops = $('.modal-backdrop.fade.show');
			if($backdrops.length === 0) return;
			$backdrops.last().css('z-index', (parseInt($self.css('z-index')) - 1));
		}

		return this.each((i, el) => {
			const $self = $(el);
			const $form = $self.find('form.atd-integration-form');

			//Reset post ID value on modal close and reset the whole form
			$self.on('hidden.bs.modal', (ev) => {
				$form[0].reset();
				$form.find('[atd-post-id]').val('');
			});

			$self.on('shown.bs.modal', (ev) => {
				styleBackdrop($self);
			});

			//Set the post id on form and then open modal
			$self.on('fr:open-locked-resource-modal', (ev, postId) => {
				$form.find('[atd-post-id]').val(postId);
				$self.modal('show');
			});
		});
	}

	$(() => {
		$('#fr-modal-'+window.salesforce_integration_modal_url_slug).lockedResourceModal();
	});
})($);